<pr-input-select-template
  formControlName="versementDistribution"
  [options]="options"
>
  <ng-template #optionTemplate let-option let-id="index">
    <div>
      <div>
        <residence-box
          [suffix]="option.suffix"
          [title]="option.label"
          [svg]="option.svg"
        ></residence-box>
      </div>
    </div>
  </ng-template>
</pr-input-select-template>
